export const topics = <const>['priorInformation', 'threat', 'tool'];

export type Topic = (typeof topics)[number];
